
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import OurRules from "../../components/ourRules";
import InfoSection from "../../components/infoSection";
import Instagram from "../../components/instagram";
import RecommendedProducts from "../../components/recommendedProducts";
import {useUI} from "@components/ui";
import MarkFavorite from "@components/product/markFavorite";
import { useAddItem } from '@framework/cart'
import useTranslation from 'next-translate/useTranslation';
import Layout from "@components/common/Layout";
import {GetServerSideProps, GetStaticPropsContext} from "next";
import storevio from "@lib/api";
import SEO from "@components/common/SEO";

// @ts-ignore
 async function _getServerSideProps({params,locale}: GetServerSideProps) {
    const topNavLinks = await storevio.getMenu(locale!,'top')
    const bottomNavLinks = await storevio.getMenu(locale!,'bottom')
    const settings = await storevio.getSettings(locale!);
    let page = null;
    try {
        page = await storevio.getPageBySlug(params.name, locale!);
    } catch (e: any) {
        if (e.status === 404) {
            return {
                notFound: true
            }
        } else {
            return {}
        }
    }

    return {
        props: {
            topNavLinks,
            bottomNavLinks,
            settings,
            page
        },
    }
}

export default function ZodpovednaVyroba({...props}) {

    return (
        <>
            <SEO
                title={props.page?.name}
                description={props.page?.description}
                openGraph={{
                    type: 'website',
                    title: props.page?.name,
                    description: props.page?.description,
                }}
            />
            <section className="content-page">
                <div className="container">
                    <h2>{props.page.name}</h2>
                    <div dangerouslySetInnerHTML={{__html: props.page.description}} />
                </div>
            </section>
            <OurRules />
            <RecommendedProducts options={props.settings} />
            <InfoSection />
            <Instagram />
        </>
    );
}

ZodpovednaVyroba.Layout = Layout;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/page/[name]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  